import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Security", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Change password", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "security-panel__info" }, "To change password, enter current password and new password", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Update password ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, { class: "security-panel" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"])),
        novalidate: ""
      }, [
        (Object.keys(_ctx.specialErrors).length > 0)
          ? (_openBlock(), _createBlock(_component_AppAlert, {
              key: 0,
              theme: "danger",
              icon: "error"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialErrors, (field) => {
                  return (_openBlock(), _createElementBlock("ul", { key: field }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(field), (error) => {
                      return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppInput, {
          id: "current-password",
          label: "Current password",
          placeholder: "Enter current password",
          type: "password",
          modelValue: _ctx.currentPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
          error: _ctx.fieldEmptyErrors.currentPassword,
          autofocus: ""
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_AppInput, {
          id: "new-password",
          label: "New password",
          placeholder: "New password",
          type: "password",
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          error: _ctx.fieldEmptyErrors.password || !!_ctx.specialErrors.password
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_AppInput, {
          id: "new-password-confirm",
          label: "Confirm new password",
          placeholder: "Confirm new password",
          type: "password",
          modelValue: _ctx.confirmPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
          error: _ctx.fieldEmptyErrors.confirmPassword || !!_ctx.specialErrors.confirmPassword
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_AppButton, {
          type: "submit",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }))
}